import { InboxErrorCode } from '@/lib/protobuf/gen/inbox/inbox_pb';

/** For triage replies, which carry only `error_code` (no `ok`). */
export function triageError(code: InboxErrorCode): { ok: false; errorCode: InboxErrorCode } | null {
  return code !== InboxErrorCode.UNSPECIFIED ? { ok: false, errorCode: code } : null;
}

export const transportFailure = { ok: false, transport: true } as const;
